package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.AddW500Rounded: ImageVector
    get() {
        if (_addW500Rounded != null) {
            return _addW500Rounded!!
        }
        _addW500Rounded = Builder(name = "AddW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(434.5f, 525.5f)
                lineTo(237.37f, 525.5f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                lineTo(434.5f, 434.5f)
                verticalLineToRelative(-197.13f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                reflectiveQuadToRelative(32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                verticalLineToRelative(197.13f)
                horizontalLineToRelative(197.13f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                lineTo(525.5f, 525.5f)
                verticalLineToRelative(197.13f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                reflectiveQuadToRelative(-32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                lineTo(434.5f, 525.5f)
                close()
            }
        }
        .build()
        return _addW500Rounded!!
    }

private var _addW500Rounded: ImageVector? = null
